module.exports = __webpack_public_path__ + "img/jt-honour-2.a5e303aa.png";